export default {
	methods: {
		//改变请求的数目
		handleSizeChange(val) {
			this.page_size = val;
			this.getMyorder();
		},
		//查看详情的按钮事件
		handleDetail(row) {
			// // console.log(row);
			this.order = row;
			this.dialogTableVisible = true;
			this.handelOrderOptions(row.id);
		},
		//查看订单的订单项目
		handelOrderOptions(id) {
			this.$post("purchased/shop_search", {
				token: this.$store.state.authority_management,
				order_id: id,
				offset: 0,
				length: 999
			}).then(res => {
				// // console.log(res.data.result.data);
				this.ordersOption = res.data.result.data;
			});
		},
		//当前页改变所触发的事件
		handleCurrentChange(val) {
			this.currentPage = val;
			this.offset = (val - 1) * this.page_size;
			this.getMyorder();
		},
		//获取订单数据
		getMyorder() {
			//pay_type 1 支付宝 2微信
			//state 0 未付款 2已付款 5已失效
			this.$post("orders/shop_search", {
				token: this.$store.state.authority_management,
				offset: this.offset,
				length: this.page_size,
				pay_type: this.pay_type_value,
				state: this.order_type_value,
				user_name: this.nameSearch,
				code: this.orderNumSearch,
				shop_id: this.$store.state.store.id
			}).then(res => {
				// // console.log(res.data);
				this.orders = res.data.result.data;
				this.total = res.data.result.total;
				return res.data.result.data;
			});
		},
		//确定搜索
		confirmSearch() {
			this.$post("orders/shop_search", {
				token: this.$store.state.authority_management,
				offset: 0,
				length: this.page_size,
				pay_type: this.pay_type_value,
				state: this.order_type_value,
				user_name: this.nameSearch,
				code: this.orderNumSearch,
				shop_id: this.$store.state.store.id
			}).then(res => {
				this.currentPage = 1
				// // console.log(res.data);
				this.orders = res.data.result.data;
				this.total = res.data.result.total;
				return res.data.result.data;
			});
		}
	},
	created() {
		this.getMyorder();
	},
	data() {
		return {
			options: [{
					value: "1",
					label: "支付宝"
				},
				{
					value: "2",
					label: "微信"
				},
				{
					value: "3",
					label: "线下支付"
				}
			],
			order_options: [{
					value: " ",
					label: "全部订单"
				},
				{
					value: "2",
					label: "已支付订单"
				},
				{
					value: "5",
					label: "已失效订单"
				},
				{
					value: "0",
					label: "未支付订单"
				}
			],
			//当前页面
			currentPage: 1,
			pay_type_value: "",
			order_type_value: "",
			orderNumSearch: "",
			nameSearch: "",
			dialogTableVisible: false,
			total: 0,
			page_size: 15,
			offset: 0,
			order: {},
			orders: [],
			ordersOption: []
		};
	}
};
